export const formatRows = (listaItems, tipovista = "completo") =>
  listaItems.map((item) => {
    const base = {
      id: item.artic_deposito_id || "Información no disponible",
      idarticulo: item.id || "Información no disponible",
      codigo: item.codigo || "Información no disponible",
      descripcion: item.descripcion || "Información no disponible",
    };

    switch (tipovista) {
      case "simple": // Caso 1: solo código y descripción
        return base;

      case "conCosto": // Caso 2: código, descripción y precio costo
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
        };

      case "mayoristaMinorista": // Caso 3: código, descripción, precio mayorista y minorista
        return {
          ...base,
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "todosPrecios": // Caso 4: código, descripción y todos los precios
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "conStock": // Caso 5: código, descripción y stock
        return {
          ...base,
          stock: item.stock ?? "0",
        };

      default: // Por defecto: todos los campos
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
          stock: item.stock ?? "Información no disponible",
        };
    }
  });

 export const formatRowsImpresion = (listaItems, tipovista = "completo") =>
  listaItems.map((item) => {
    const base = {
      id: item.artic_deposito_id || "Información no disponible",
      idarticulo: item.id || "Información no disponible",
      codigo: item.codigo || "Información no disponible",
      descripcion: item.descripcion || "Información no disponible",
    };

    switch (tipovista) {
      case "simple": // Caso 1: solo código y descripción
        return base;

      case "conCosto": // Caso 2: código, descripción y precio costo
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
        };

      case "mayoristaMinorista": // Caso 3: código, descripción, precio mayorista y minorista
        return {
          ...base,
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "todosPrecios": // Caso 4: código, descripción y todos los precios
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "conStock": // Caso 5: código, descripción y stock
        return {
          ...base,
          stock: item.stock ?? "0",
        };

      default: // Por defecto: todos los campos
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
          stock: item.stock ?? "Información no disponible",
        };
    }
  }); 
